import './types/imports';
import Vue from 'vue';
import PortalVue from 'portal-vue';
import App from './App.vue';
import router from './router.index';
import store from './store.index';
import vuetify from './pluggins/vuetify';
import { EventBus, Utiles } from './pluggins/event-bus';
import { register } from 'register-service-worker';
import WebCam from "vue-web-cam";

import moment from 'moment';
moment.locale( 'es' );

import { settings as Settings } from './ext';
import { socket as Socket, SocketAdmin } from './ext';
import { UsuarioActual } from './shared/login/autenticar';

Settings.Init();
SocketAdmin.Init();

import VueSocketIOExt from 'vue-socket.io-extended';



Vue.use( VueSocketIOExt, Socket );
Vue.use( PortalVue );
Vue.use( vuetify );
Vue.use( WebCam );


Vue.config.productionTip = false;

Utiles.ControladorDeNotificaciones.Iniciar();
Vue.prototype.$EventBus = Vue.observable( Utiles );
Vue.prototype.$Usuario = Vue.observable( UsuarioActual );

const VueRoot = new Vue( {
    router,
    store,
    vuetify,
    render: h => h( App )
} ).$mount( '#app' );


var swRegistration: ServiceWorkerRegistration = null;
var isSubscribed: boolean = false;

function initialiseUI()
{
    // Set the initial subscription value
    swRegistration.pushManager.getSubscription()
        .then( function ( subscription )
        {
            isSubscribed = !( subscription === null );

            if ( isSubscribed )
            {
                //console.log( 'User IS subscribed.' );
            } else
            {
                //console.log( 'User is NOT subscribed.' );
            }


        } );
}

//if ( 'serviceWorker' in navigator && 'PushManager' in window )
//{
//    console.log( 'Service Worker and Push is supported' );

//    navigator.serviceWorker.register( '../sw.js' )
//        .then( function ( swReg )
//        {
//            console.log( 'Service Worker is registered', swReg );

//            swRegistration = swReg;
//            initialiseUI();
//        } )
//        .catch( function ( error )
//        {
//            console.error( 'Service Worker Error', error );
//        } );
//} else
//{
//    console.warn( 'Push messaging is not supported' );
//}

register( '../sw.js', {
    ready()
    {
//        console.log( 'Site is ready' );
    },
    cached()
    {
//        console.log( 'Content has been cached for offline use.' );
    },
    updatefound()
    {
//        console.log( 'New content is downloading.' );
    },
    updated()
    {
//        console.log( 'New content is available; Refresh...' );
        Utiles.NuevaVersion( true );
    },
    offline()
    {
        //console.log( 'No internet connection found. App is running in offline mode.' );
    },
    error( error )
    {
        //console.error( 'Error during service worker registration:', error );
    },
} );
export var ModoDeVistaActual: string = '';
window.addEventListener( 'DOMContentLoaded', () =>
{
    let displayMode = 'browser tab';
    if ( navigator.standalone )
    {
        displayMode = 'standalone-ios';
    }
    if ( window.matchMedia( '(display-mode: standalone)' ).matches )
    {
        displayMode = 'standalone';
    }
    // Log launch display mode to analytics
    //console.log( 'DISPLAY_MODE_LAUNCH:', displayMode );
    ModoDeVistaActual = displayMode;

} );


export { Settings, Socket, VueRoot };